import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Util from './utils/util'
import Client from './utils/client'

Vue.config.productionTip = false
Vue.prototype.$util = Util;
Vue.prototype.$client = Client;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
